import { Badge, BadgeVariant } from "@/components/ui/Badge";

const getBadgeVariant = (isNoChange: boolean, isImprovement: boolean): BadgeVariant => {
  if (isNoChange) {
    return BadgeVariant.GRAY;
  }

  if (isImprovement) {
    return BadgeVariant.GREEN;
  }

  return BadgeVariant.RED;
};

const getArrowSymbol = (isImprovement: boolean, isNoChange: boolean): string => {
  if (isImprovement) {
    return "↑";
  }

  if (isNoChange) {
    return "–";
  }

  return "↓";
};

export const ComparisonBadge = ({ percentageDifference }: { percentageDifference: number }) => {
  const isImprovement = percentageDifference > 0;
  const isNoChange = percentageDifference === 0;

  return (
    <div className="flex items-center justify-center">
      <Badge variant={getBadgeVariant(isNoChange, isImprovement)} className="text-sm">
        <span className="mr-1">{getArrowSymbol(isImprovement, isNoChange)}</span>
        {Math.abs(percentageDifference).toFixed(1)}%
      </Badge>
    </div>
  );
};
